import React from "react";
import { Link } from "react-router-dom";
import solarResources from "./solarResources";
import "../../styles/solar-resources.css";
import { FaFilePdf } from "react-icons/fa";
import BlogList from "../../components/BlogList";

export default function SolarResourcesPage() {
  return (
    <div className="solar-resources-page">
      
      <img src="/images/solarpower.png" alt="" className="card-iconpanelservicecenters" />
      <div className="resourcesheader">
      <h2>📚 Solar Training PDFs</h2>
      </div>
      <div className="resource-list">
        {solarResources.map((res) => (
          <div className="resource-card" key={res.id}>
            <div className="card-header">
              <FaFilePdf className="resource-icon" />
              <h3>{res.title}</h3>
            </div>
            <p className="description">{res.description}</p>
            <div className="card-footer">
              <span className="price-badge">₦{res.price}</span>
              <Link to={`/solar-resources/${res.id}`} className="btn">View Details</Link>
            </div>

          </div>
        ))}
      </div>
      <BlogList />
    </div>
  );
}
